const data = {
  title: "Floor 2-2",
  musicTrack: "MUSIC_WORLD2",
  theme: "GREEN",
  tilesWidth: 9,
  tilesHeight: 7,
  placements: [
    {
      type: "HERO_SPAWN",
      x: 2,
      y: 2,
    },
    {
      type: "PLACEMENT_TYPE_GOAL",
      x: 8,
      y: 6,
    },
    {
      type: "WALL",
      x: 8,
      y: 8,
    },
    {
      type: "WALL",
      x: 6,
      y: 8,
    },
    {
      type: "WALL",
      x: 2,
      y: 8,
    },
    {
      type: "WALL",
      x: 4,
      y: 2,
    },
    {
      type: "WALL",
      x: 4,
      y: 4,
    },
    {
      type: "WALL",
      x: 6,
      y: 6,
    },
    {
      type: "WALL",
      x: 6,
      y: 4,
    },
    {
      type: "WALL",
      x: 4,
      y: 8,
    },
    {
      type: "WALL",
      x: 4,
      y: 1,
    },
    {
      type: "WALL",
      x: 4,
      y: 5,
    },
    {
      type: "WALL",
      x: 4,
      y: 7,
    },
    {
      type: "WALL",
      x: 6,
      y: 7,
    },
    {
      type: "WALL",
      x: 6,
      y: 1,
    },
    {
      type: "WALL",
      x: 6,
      y: 3,
    },
    {
      type: "ENEMY_SPAWN",
      x: 5,
      y: 6,
      direction: "UP",
      enemyType: "ENEMY",
    },
    {
      type: "CHIP",
      x: 5,
      y: 1,
    },
    {
      type: "CHIP",
      x: 5,
      y: 7,
    },
    {
      type: "SWITCH_WALL",
      x: 5,
      y: 4,
      isRaised: false,
    },
    {
      type: "SWITCH",
      x: 2,
      y: 6,
    },
    {
      type: "SWITCH",
      x: 8,
      y: 2,
    },
  ],
};

export default data;
